// extracted by mini-css-extract-plugin
export default {"popup":"PopupRank_popup__jsIcW","popup__head":"PopupRank_popup__head__Adivm","info":"PopupRank_info__3yqVF","close":"PopupRank_close__7cGRg"};